import {
  MembershipDTO,
  OrganizationDTOV2,
  UserDtoV3,
  UserOrganizationDto,
} from 'src/api/generated'
import { ApiResponseSerializer } from 'src/v2/commons/interface/ApiResponseSerializer'

import { IUserMembership } from '../membership/membership.types'

export enum UserType {
  REGULAR = 'regular',
  EXTERNAL = 'external',
  TEST = 'test',
  INTEGRATION = 'integration',
  DOCTOR = 'doctor',
}

export const USER_TYPE_OPTIONS = [
  { value: UserType.REGULAR, label: 'Regular' },
  { value: UserType.EXTERNAL, label: 'External' },
  { value: UserType.TEST, label: 'Test' },
  { value: UserType.INTEGRATION, label: 'Integration' },
]

export interface IUser {
  id?: string
  firstName: string
  lastName: string
  username?: string
  hipaaCertified?: boolean
  aircallUserId?: string
  email?: string
  phone?: string
  password?: string
  membership?: IUserMembership
  emailDomains?: IMembershipEmailDomainUser[]
  type?: UserType
}

// export inteRface IUserOrganization {
//   id: string
//   email: string
//   name: string
//   status: string
//   role: string
// }

export type UsersResponseModel = ApiResponseSerializer<UserOrganizationDto>

export interface IMembershipEmailDomainUser {
  id: string
  type: 'BOTH' | 'SEND' | 'REPLY'
  name: string
  domain: string
  isWBFRegister: boolean
}

export interface ITokenPayload {
  exp: number
  iat: number
  id: string
  membershipId: string
  organizationId: string
  parentTokenId: string
  sub: string
  userId: string
}

export interface IUserSessionStore {
  user: Omit<UserDtoV3, 'membership' | 'emailDomains'> & {
    email: string
  }
  membership: MembershipDTO
  currentOrganization: OrganizationDTOV2
  organizations: OrganizationDTOV2[]
  tokenPayload: ITokenPayload
  policies: string[]
}

export const LOCAL_STORAGE_USER_PROFILE = 'USER_PROFILE_SESSION'

export interface IUsersFilter {
  status?: string
  limit?: number
  offset?: number
  search?: string
  orderBy?: string
  userType?: UserType
  organizationRole?: string
}

export type OrderByType = 'ASC' | 'DESC' | undefined

export interface ICreateUserRequest
  extends Pick<
    UserDtoV3,
    | 'id'
    | 'firstName'
    | 'lastName'
    | 'phone'
    | 'username'
    | 'aircallUserId'
    | 'type'
  > {
  organizationId: string
  hipaaCertified?: string
  password: string
}
